import controller from './specific-time.controller';

const template = require('./specific-time.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/alerts-actions/alerts-actions-content/time-period/specific-time/specific-time.component.js